import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DictionaryUnitConverterEntity } from '../types';

@Injectable({
  providedIn: 'root'
})
export class DictionaryUnitConverterService {

  constructor(private http: HttpClient) { }

  getAll(): Observable<DictionaryUnitConverterEntity[]> {
    return this.http.get<DictionaryUnitConverterEntity[]>('/api/dictionary/unit-converter');
  }

  getById(id: number): Observable<DictionaryUnitConverterEntity[]> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<DictionaryUnitConverterEntity[]>('/api/dictionary/unit-converter', { params });
  }

  add(record: DictionaryUnitConverterEntity): Observable<void> {
    return this.http.post<void>('/api/dictionary/unit-converter', record);
  }

  delete(record: DictionaryUnitConverterEntity): Observable<void> {
    return this.http.delete<void>('/api/dictionary/unit-converter', { body: record });
  }
}

